import { RootState } from "@/store"

export const getAllResources = (state: RootState) => state.resource
